import React, { useCallback, useContext } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import AdminActions from '@components/AdminActions';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';
import rolesConstants from '@utils/rolesConstants';

import * as S from './styles';

interface GroupTagProps {
  group: {
    id: string;
    name: string;
    usernames: string[];
  };
  handleActions: (actionType: 'UPDATE' | 'DELETE', userId: string) => void;
  notShowAdmin?: boolean;
}

const GroupTag = ({
  group: { id, name, usernames },
  notShowAdmin,
  handleActions,
}: GroupTagProps) => {
  const { t } = useTranslation('roles');
  const { effectiveRoles } = useContext(SessionContext);

  const rolesToAccess = effectiveRoles?.portal;
  const isCustomerCanManage = rolesToAccess?.includes(
    rolesConstants.MANAGE_GROUPS,
  );

  const adminActions = useCallback(
    () => (
      <AdminActions
        alertDelete={t('modal.delete.alert')}
        entityToExclude={name}
        ruleToNotExclude={name === 'ADMINISTRATORS'}
        onEdit={() => handleActions('UPDATE', id)}
        onDelete={() => handleActions('DELETE', id)}
      />
    ),
    [handleActions, id, name, t],
  );

  const renderUsersButton = (
    <Button
      style={{
        marginLeft: 8,
        padding: '0 8px',
      }}
    >
      {usernames?.length}
      <UserOutlined style={{ marginLeft: 4 }} />
    </Button>
  );

  return (
    <S.GroupTag key={id} type="solid">
      <span style={{ margin: '0 8px' }}>{name}</span>

      <div style={{ display: 'flex' }}>
        <Tooltip
          title={
            usernames?.length > 0
              ? t('msgs.usersWithThisProfile', { count: usernames?.length })
              : t('msgs.noUsersWithThisProfile')
          }
        >
          {usernames?.length > 0 ? (
            <Dropdown
              menu={{
                items: usernames?.map(user => ({
                  key: user,
                  label: user,
                })),
              }}
              overlayClassName="group-tag-dropdown"
            >
              {renderUsersButton}
            </Dropdown>
          ) : (
            renderUsersButton
          )}
        </Tooltip>

        {isCustomerCanManage && !notShowAdmin && adminActions()}
      </div>
    </S.GroupTag>
  );
};

export default GroupTag;
